import React, { useEffect, useState } from 'react'
import "./confirmForgetPassword.scss";

import HeaderRegistration from '../registration/components/headerRegistration/HeaderRegistration';
import { Button, Stack } from 'react-bootstrap';
import { t } from 'i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { resetPasswordWS } from './api/confirmForgetPasswordApi';

const ConfirmForgetPassword = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [show, setShow] = useState(false);
    const [error, setError] = useState(true);

    useEffect(() => {
        resetPasswordWS({ id }).then((res) => {
            setShow(true);
            setError(false);
        }).catch((err) => { console.error(err); setError(true); });

    }, [])

    console.log(id);

    return (
        <>
            <div className='container-confirm-forget-password'>
                {show ?
                    <div className='confirm-forget-password'>
                        <Stack gap={3}>
                            <HeaderRegistration
                                title={!error ?
                                    t("confirm_forget_password.title") :
                                    t("confirm_forget_password.title_error")
                                }
                                subtitle={!error ?
                                    t("confirm_forget_password.subtitle") :
                                    t("confirm_forget_password.subtitle_error")
                                }
                            />
                            <Button variant="light" size="md"
                                onClick={() => {
                                    navigate("../login");
                                }}
                            >{t("login.title")}</Button>
                        </Stack>
                    </div>
                    : null}
            </div>
        </>
    )
}

export default ConfirmForgetPassword
